import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {ApplicationService, ContactService} from '../../../services';
import {Subject} from 'rxjs';
import * as _ from 'lodash';
import {noSameValues} from '../../../_global/validators/custom-validators.directive';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {DataHandlerService} from '../../../services/data-handler.service';
import { AddressSuggestionsComponent } from '../address-suggestions/address-suggestions.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ValidationPartialComponent } from '../partials';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { NgFor, NgIf, NgClass, UpperCasePipe } from '@angular/common';
import {
  SensisMobileComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-mobile/sensis-mobile.component';
import {
  SensisEmailComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/sensis-email/sensis-email.component';
import {
  AddressSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/address-search/address-search.component';

@Component({
    selector: 'app-trust-details',
    templateUrl: './trust-details.component.html',
    styles: [],
    standalone: true,
    imports: [NgFor, MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, NgIf, MatFormFieldModule, MatFormFieldModule,
      MatInputModule, MatInputModule, ValidationPartialComponent, NgClass, MatCheckboxModule, MatCheckboxModule,
      AddressSuggestionsComponent, UpperCasePipe, SensisMobileComponent, SensisEmailComponent, AddressSearchComponent]
})
export class TrustDetailsComponent extends WizardWidgetComponent implements OnInit, OnDestroy {

  @Input() public formGroup: UntypedFormGroup;
  @Input() public selectedAbnResults: any;
  @Input() public personList: any;
  @Input() public companyList: any;
  @Input() public trustCompanyContactList: any;
  @Input() public borrowerType: any;
  public trustFormArray;
  public postSettlementAddressAsTradingState = [];
  public selectedAddress = [];
  public selectedContacts = [];
  public contactList = [];
  private unsubscribe$ = new Subject();

  public currentFormGroupState: any[] = [];
  public subscriptions: any = [];

  private readonly contactType = 'trust';

  constructor(
    private applicationService: ApplicationService,
    public dataHandleService: DataHandlerService,
    public contactService: ContactService,
  ) {
    super(dataHandleService);
  }

  ngOnInit() {
    this.trustFormArray = this.formGroup;
    this.trustFormArray.setValidators(noSameValues('trustName'));
    this.trustFormArray.updateValueAndValidity();
    this.currentFormGroupState = this.trustFormArray.value;

    // Get form value changes
    this.checkAddresses(this.trustFormArray.value);

    this.dataHandleService.getBorrowerTypeData().subscribe((result: any) => {
      this.borrowerType = result;
      this.checkContactList();
    });

    this.contactService.selectedContactsListener
      .pipe(debounceTime(750))
      .subscribe((result: any) => {
        this.selectedContacts = (result) ? result : [];
        this.checkContactList();
      });

    this.trustFormArray.valueChanges
      .pipe(debounceTime(750))
      .subscribe((trustDetails: any[]) => {
        trustDetails.forEach((trustDetail, index) => {
          const currentTrust = this.currentFormGroupState[index];
          if (!(_.isEqual(currentTrust, trustDetail))) {
            if (!currentTrust || !(_.isEqual(currentTrust.tradingAddress, trustDetail.tradingAddress))) {
              this.duplicateAddresses(trustDetail, index);
            }
            this.saveContactList(trustDetail, index);
            this.currentFormGroupState[index] = trustDetail;
          }
        });
      });
    this.contactService.contactListListener
      .pipe(debounceTime(750))
      .subscribe((payload) => {
        this.contactList = payload;
        this.checkContactDetails();
      });
    this.createContactList();
    this.checkContactDetails();
  }

  createContactList() {
    this.trustFormArray.controls.forEach((trust: UntypedFormGroup, index: number) => {
      this.saveContactList(trust.value, index);
    });
    this.checkContactList();
  }

  /**
   * save to contact list
   * @param dataInput
   * @param index
   */
  public async saveContactList (dataInput, index: number) {
    this.contactService.save({
      companyTrustName: (dataInput.trustName) ? dataInput.trustName : 'Trust ' + (index + 1),
      contactName: dataInput.trustContactName,
      contactPosition: dataInput.trustContactPosition,
      contactMobile: dataInput.trustContactMobile,
      contactEmail: dataInput.trustContactEmail,
      index,
      type: this.contactType,
      isDisabled: false
    });
  }

  checkContactList() {
    this.contactService.addContactFieldsIfNotExists(this.trustFormArray, this.contactType);
  }

  setContact(event, formGroup, contact, index) {
    console.log('setContact', event, formGroup, contact);

    if (event.checked) {
      this.contactService.updateContactControlEnableStatus(formGroup, false, this.contactType);

      console.log('contactSelected', contact.identity);

      formGroup.get('contactSelected').patchValue(contact.identity);
      this.contactService.addToSelectedContacts(contact.identity);
      this.setContactValidators(formGroup, true, contact);
    } else {
      const contactToUpdate =  this.contactService.getContact(this.contactService.getContactIdentity(this.contactType, index));

      if (contactToUpdate) {
        contactToUpdate.contactName = '';
      }

      this.setContactValidators(formGroup, false);
      this.contactService.updateContactControlEnableStatus(formGroup, true, this.contactType);
      formGroup.get('contactSelected').patchValue(null);

      this.contactService.removeToSelectedContacts(contact.identity);
      this.checkContactList();
    }
  }

  checkContactDetails() {
    this.contactService.checkContactDetails(this.trustFormArray, this.contactType);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  getPopulatedEntities(data, type) {
    const entities = [];
    if (data) {
      data.forEach((element, index) => {
        element.id = index;
        if (element[`${type}ContactName`] &&
          element[`${type}ContactPosition`] &&
          element[`${type}ContactMobile`] &&
          element[`${type}ContactEmail`]) {
          entities.push({...element, type});
        }
      });
    }

    return entities;
  }

  checkAddresses(data) {
    // console.log('[checkAddresses]', data);
    for (let i = 0; i < data.length; i++) {
      this.duplicateAddresses(data[i], i);
    }
  }
  duplicateAddresses (payload, index) {
    this.addressAsAbove(index, 'postalAddress', payload);
    this.addressAsAbove(index, 'postSettlementAddress', payload);
  }
  addressAsAbove(index, formControlName, data) {
    const fg = this.trustFormArray.at(index);
    if (data && data[`${formControlName}AsTrading`] === true && fg) {
      if (fg.get('tradingAddress').touched) {
        fg.patchValue({[formControlName]: data['tradingAddress']}, {emitEvent: false});
        fg.get(formControlName).updateValueAndValidity();
        fg.get(formControlName).markAsTouched();
      }
    }
  }

  setContactValidators(control, set: Boolean, data?: any) {
    this.contactService.setContactValidators(control, set, data, this.contactType);
  }
}
